if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (FoxTheme.config.motionReduced) return;
      this.promotion = this.querySelector('.promotion');
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        // ✅ Ajout: drag au doigt / souris (sans casser l'auto-scroll)
        this.setupDragScroll();

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    setupDragScroll() {
      // On a besoin d'un conteneur scrollable : ici, ton custom element (this)
      // Assure-toi côté CSS que le conteneur peut scroller horizontalement :
      // overflow-x: auto; -webkit-overflow-scrolling: touch;
      // (si déjà en animation via transform, ça reste OK: on "force" juste scrollLeft pendant le drag)

      this.style.touchAction = 'pan-y'; // autorise le scroll vertical de la page, mais on capte l'horizontal

      let isPointerDown = false;
      let startX = 0;
      let startScrollLeft = 0;
      let hasDragged = false;
      let resumeTimer = null;

      const onPointerDown = (e) => {
        // uniquement bouton principal souris, et tous pointeurs (touch/pen/mouse)
        if (e.pointerType === 'mouse' && e.button !== 0) return;

        isPointerDown = true;
        hasDragged = false;
        startX = e.clientX;
        startScrollLeft = this.scrollLeft;

        // pause immédiatement pendant l'interaction
        clearTimeout(resumeTimer);
        this.scrollingPause();

        // capture pour continuer à recevoir les events même si on sort de l'élément
        this.setPointerCapture?.(e.pointerId);
      };

      const onPointerMove = (e) => {
        if (!isPointerDown) return;

        const dx = e.clientX - startX;
        if (Math.abs(dx) > 3) hasDragged = true;

        // On inverse pour que "tirer à gauche" fasse défiler vers la droite (comportement naturel)
        this.scrollLeft = startScrollLeft - dx;

        // Empêche la page de scroller horizontalement pendant le drag
        if (hasDragged) e.preventDefault();
      };

      const endDrag = (e) => {
        if (!isPointerDown) return;
        isPointerDown = false;

        try {
          this.releasePointerCapture?.(e.pointerId);
        } catch (_) {}

        // Reprend l'auto-scroll après un court délai
        resumeTimer = setTimeout(() => {
          this.scrollingPlay();
        }, 600);
      };

      // listeners
      this.addEventListener('pointerdown', onPointerDown, { passive: true });
      this.addEventListener('pointermove', onPointerMove, { passive: false }); // important pour preventDefault
      this.addEventListener('pointerup', endDrag, { passive: true });
      this.addEventListener('pointercancel', endDrag, { passive: true });

      // Bonus : si la user pose juste le doigt sans drag, on pause un instant puis on reprend
      this.addEventListener(
        'touchstart',
        () => {
          clearTimeout(resumeTimer);
          this.scrollingPause();
          resumeTimer = setTimeout(() => this.scrollingPlay(), 600);
        },
        { passive: true }
      );
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
